(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swym-registry-manage"]) return;
  try {
    
  const swymRegistry_pageWrapper = document.getElementsByClassName("swym-registry-wrapper")[0];
  const swymRegistry_manageHeader = document.getElementsByClassName("swym-registry-manage-page-header")[0];
  const swymRegistry_manageGridLists = document.getElementsByClassName("swym-registry-manage-page-grid-section")[0];
  const swymRegistry_headerTotalRegistries = document.getElementById("swym-registry-manage-page-header-info-total-registries");
  const swymRegistry_gridLists = document.getElementById("swym-registry-manage-page-grid-lists");

 async function swymRegistryOnloadHandler() {
      if(!Shopify.designMode) {
        if(document.querySelector('#swym-registry-share-mail-link')){  
        document.querySelector('#swym-registry-share-mail-link').addEventListener('click',() => {
          _LTracker.push({
            'eventInfo': 'Share by mail button clicked - Manage',
            'tag': 'event'
          });
          Shopify.analytics.publish("swym_registry_manage_view",{"eventAction": "Share by mail button clicked","customerInfo":{
            "name"  : "{{ customer.name }}",
            "email" : "{{ customer.email }}",
            "id"    : "{{ customer.id }}"
          }});
        });
        }
        async function swymRegistry_getRegistryByEmail(authData) {
          const swymRegistry_customerEmail = swymRegistryCustomer.email;
          const token = authData.swym_registry.jwt.token
          return swymRegistry_getAllRegistries(swymRegistry_customerEmail,token)
          .then((response) => response.json())
          .then((data) => {
            if(data.length) {
              try {
                // Add total registry count & Show content
                swymRegistry_headerTotalRegistries.innerText = data.length > 1 ? data.length + " " +swymRegistryStrings.swym_registry_registries_label : data.length + " " + swymRegistryStrings.swym_registry_registry_label;

                swymRegistry_manageHeader.style.visibility = "visible";
                swymRegistry_pageWrapper.style.visibility = "visible";
                // Add Grid Lists
                data.forEach(registry => {
                  let swymRegistry_fname = registry.address.firstName, swymRegistry_lname = registry.address.lastName, swymRegistry_initials;
                  if(swymRegistry_fname && swymRegistry_lname) {
                    swymRegistry_initials = swymRegistry_fname.charAt(0) + swymRegistry_lname.charAt(0);
                  }
                  else {
                     swymRegistry_initials = registry.creatorName.charAt(0);
                  }
      
                  swymRegistry_gridLists.innerHTML += `
                    <li id="swym-registry-manage-page-grid-lists-list-${registry.Id}" class="swym-registry-manage-page-grid-lists-list">
                      <div class="swym-registry-manage-page-grid-lists-circle-parent">
                        <div class="swym-registry-manage-page-grid-lists-circle">
                          <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-font-very-large">${swymRegistry_initials}</p>
                        </div>
                      </div>
                      <div class="swym-registry-manage-page-grid-lists-registry-info-parent">
                        <h3 class="swym-registry-font-sub-title">${registry.registryName}</h3>
                        <span class="swym-registry-gifter-banner-edit" onclick="swymRegistry_manageEditRegistryBtn(${registry.Id})">
                          <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewbox="0 0 50 50"><path d="M9 39h2.2l22.15-22.15-2.2-2.2L9 36.8Zm30.7-24.3-6.4-6.4 2.1-2.1q.85-.85 2.1-.85t2.1.85l2.2 2.2q.85.85.85 2.1t-.85 2.1Zm-2.1 2.1L12.4 42H6v-6.4l25.2-25.2Zm-5.35-1.05-1.1-1.1 2.2 2.2Z"/></svg>
                        </span>
                        <span class="swym-registry-gifter-banner-share" onclick="swymRegistryOpenShareModal(\`${registry.registryName}\`,${registry.Id},${registry.settings.isPasswordProtected},\`${registry.email}\`,\`${token}\`,\`${registry.occasion}\`)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewbox="0 0 50 50"><path d="M36.35 44q-2.35 0-4.025-1.675Q30.65 40.65 30.65 38.3q0-.35.075-.825t.225-.875L15.8 27.8q-.75.85-1.85 1.375t-2.25.525q-2.35 0-4.025-1.675Q6 26.35 6 24q0-2.4 1.675-4.05T11.7 18.3q1.15 0 2.2.45 1.05.45 1.9 1.3l15.15-8.7q-.15-.35-.225-.8-.075-.45-.075-.85 0-2.4 1.675-4.05T36.35 4q2.4 0 4.05 1.65t1.65 4.05q0 2.35-1.65 4.025-1.65 1.675-4.05 1.675-1.15 0-2.225-.375Q33.05 14.65 32.3 13.8l-15.15 8.4q.1.4.175.925.075.525.075.875t-.075.75q-.075.4-.175.8l15.15 8.6q.75-.7 1.75-1.125 1-.425 2.3-.425 2.4 0 4.05 1.65t1.65 4.05q0 2.35-1.65 4.025Q38.75 44 36.35 44Zm0-31.6q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q37.5 7 36.35 7t-1.925.775q-.775.775-.775 1.925t.775 1.925q.775.775 1.925.775ZM11.7 26.7q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q12.85 21.3 11.7 21.3t-1.925.775Q9 22.85 9 24t.775 1.925q.775.775 1.925.775ZM36.35 41q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q37.5 35.6 36.35 35.6t-1.925.775q-.775.775-.775 1.925t.775 1.925Q35.2 41 36.35 41Zm0-31.3ZM11.7 24Zm24.65 14.3Z"/></svg>
                        </span>
                        <ul class="swym-registry-manage-page-grid-lists-registry-info swym-registry-font-small">
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_reg_id_label}</span> : <span id="swym-registry-manage-page-info-value"><strong>${registry.Id}</strong></span>
                          </li>
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_event_date_label }</span>  : <span id="swym-registry-manage-page-info-value"><strong>${registry.expiryDate}</strong></span>
                          </li>
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_event_type_label }</span> : <span id="swym-registry-manage-page-info-value"><strong>${registry.occasion}</strong></span>
                          </li>
                        </ul>
                        <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-manage-page-grid-lists-registry-description-title swym-registry-font-small" id="swym-registry-manage-page-grid-lists-registry-description-title-${registry.Id}"><strong>${swymRegistryStrings.swym_registry_description_label }</strong></p>
                        <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-manage-page-grid-lists-registry-description swym-registry-font-small" id="swym-registry-manage-page-grid-lists-registry-description-${registry.Id}">
                          ${registry.description}
                        </p>
                        <div class="swym-registry-manage-page-grid-lists-registry-btn-parent">
                          <a class="${swymRegistryStrings.swym_registry_custom_link_class }">
                            <button class="${swymRegistryStrings.swym_registry_custom_btn_class } swym-registry-manage-page-grid-lists-registry-btn" onClick="swymRegistry_manageViewRegistryBtn(${registry.Id})">${swymRegistryStrings.swym_registry_view_registry_button_label}</button>
                          </a>
                        </div>
                      </div>
                    </li>
                  `;
                  if(registry.description.length===0){
                    document.querySelector(`#swym-registry-manage-page-grid-lists-registry-description-title-${registry.Id}`).style.display='none';
                    document.querySelector(`#swym-registry-manage-page-grid-lists-registry-description-${registry.Id}`).style.display='none';
                  }
                  return "success";
                }) 
              }
              catch (error) {
                console.error("Error in showing list of registries for user: ", error);
                return "failed";
              }
            }
            else {
              //show empty state
              try {
                const swymRegistry_emptyCardSection = document.getElementById("swym-registry-manage-page-empty-section");
  
                swymRegistry_headerTotalRegistries.innerText = "0 " + swymRegistryStrings.swym_registry_registry_label;
                swymRegistry_manageHeader.style.visibility = "visible";
                swymRegistry_pageWrapper.style.visibility = "visible";
                swymRegistry_manageGridLists.style.display = "none";
                swymRegistry_emptyCardSection.style.display = "block";
  
                document.getElementById("swym-registry-manage-page-create-btn").addEventListener("click", function(e){
                  e.preventDefault();
                  Shopify.analytics.publish("swym_registry_manage_view",{"eventAction": "Create Registry button clicked","customerInfo":{
                    "name"  : "{{ customer.name }}",
                    "email" : "{{ customer.email }}",
                    "id"    : "{{ customer.id }}"
                  }});
                  window.location = "/pages/swym-registry-form?mode=create";
                });

              } catch (error) {
                console.log("Error in Showing 'No registries found card'", error);
              }
            } 
          }).catch(error => {
             _LTracker.push({
                'ErrorLocation': 'Get all registries API call - Manage Template',
                'ErrorInfo': {
                  "error": {
                    "msg": error.message,
                    "Reference_stack": error.stack
                  }
                },
               'MerchantInfo': {
                'pid': authData.swym_registry.pid,
                'shop': Shopify.shop,
                'themeId': Shopify.theme.id,
                'themeName': Shopify.theme.name
              },
              'CustomerInfo': {
                'customerId': authData.swym_registry.customerId,
                'customerEmail': swymRegistryCustomer.email,
                 'userAgent': navigator.userAgent 
              }
              }); 
          })
        }
        
        var swymRegistry_lsInit = JSON.parse(localStorage.getItem(swymRegistry_lsName));
        const swymRegistry_authData = await swymRegistry_refreshAuth(swymRegistryCustomer, swymRegistry_lsInit);
        swymRegistry_getRegistryByEmail(swymRegistry_authData);
        document.querySelector("#swym-registry-copy-text").value = window.location.href;
      }
  };

swymRegistryAddOnloadEvent(swymRegistryOnloadHandler);

  } catch(e) { console.error(e); }
})();
})();
